import DateInput from 'components/inputs/DateInput'
import { observer } from 'mobx-react'
import React from 'react'
import {
  FilterViewDivider,
  FilterViewHeader,
  FilterViewItem,
  FilterViewItemContainer,
} from '..'
import { DateRangeFilter } from './DateRangeFilter'

interface DateRangeFilterViewProps<TFilters extends Record<string, unknown>> {
  filter: DateRangeFilter<keyof TFilters>
}

export const DateRangeFilterView = observer(function DateRangeFilterView<
  TFilters extends Record<string, unknown>,
>({ filter }: DateRangeFilterViewProps<TFilters>) {
  return (
    <>
      <FilterViewHeader
        title={filter.title}
        dataTest={'job-date-range-filter-clear-button'}
        onClear={() => {
          filter.clearValue()
          filter.stopEditing()
        }}
      />
      <FilterViewItemContainer>
        <FilterViewItem title="Date from">
          <DateInput
            icon="change-start-date"
            compact={true}
            dataTest={'job-date-range-filter-from-field'}
            value={filter.value?.from ?? undefined}
            onChange={filter.setFrom}
          />
        </FilterViewItem>
        <FilterViewDivider />
        <FilterViewItem title="Date to">
          <DateInput
            icon={'override-deadline'}
            compact={true}
            dataTest={'job-date-range-filter-to-field'}
            value={filter.value?.to ?? undefined}
            onChange={filter.setTo}
          />
        </FilterViewItem>
      </FilterViewItemContainer>
    </>
  )
})
